
export const CONFIGURABLE_OPERATION_FRAGMENT = /* GraphQL */ `
    fragment ConfigurableOperation on ConfigurableOperation {
        args {
            name
            value
        }
        code
    }
`;

export const CONFIGURABLE_OPERATION_DEF_FRAGMENT = /* GraphQL */ `
    fragment ConfigurableOperationDef on ConfigurableOperationDefinition {
        args {
            name
            type
            required
            defaultValue
            list
            ui
            label
            description
        }
        code
        description
    }
`;

export const ERROR_RESULT_FRAGMENT = /* GraphQL */ `
    fragment ErrorResult on ErrorResult {
        errorCode
        message
    }
`;
